import { render, staticRenderFns } from "./OTPInput.vue?vue&type=template&id=caaa4fec&scoped=true"
import script from "./OTPInput.vue?vue&type=script&lang=js"
export * from "./OTPInput.vue?vue&type=script&lang=js"
import style0 from "./OTPInput.vue?vue&type=style&index=0&id=caaa4fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaa4fec",
  null
  
)

export default component.exports